export const OFFICE_PRODUCT_GALLERY_OPEN = "OFFICE_PRODUCT_GALLERY_OPEN";
export const OFFICE_PRODUCT_GALLERY_CLOSE = "OFFICE_PRODUCT_GALLERY_CLOSE";

export const openOfficeProductGallery = ({
    officeId,
    productId,
    title = "",
    thumbnail = "",
    source = "",
} = {}) => ({
    type: OFFICE_PRODUCT_GALLERY_OPEN,
    payload: {
        open: true,
        officeId: String(officeId || ""),
        productId: String(productId || ""),
        title: String(title || ""),
        thumbnail: String(thumbnail || ""),
        source: String(source || ""),
        openedAt: Date.now(),
    },
});

export const closeOfficeProductGallery = () => ({
    type: OFFICE_PRODUCT_GALLERY_CLOSE,
});
